__turbopack_context__.v({
  "calc": "SubnetCalculator-module__fv5vbG__calc",
  "scroller": "SubnetCalculator-module__fv5vbG__scroller",
});
